import CryptoJS from "crypto-js";

export function DecodingString(string) {
  let plainText = "";
  if (string) {
    const encryptedText = string.split(".")[0]; // The AES-encrypted text

    const secretKey = process.env.REACT_APP_PUBLIC_KEY_DECODE_STRING;
    const initializationVector = string.split(".")[1];
    // console.log(secretKey, initializationVector);

    // Convert the secret key and initialization vector to WordArray
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(initializationVector);

    // Decrypt the encrypted text
    const decryptedText = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Convert the decrypted WordArray to plaintext
    plainText = decryptedText.toString(CryptoJS.enc.Utf8);

    // console.log("Decrypted Text:", plainText);
  }
  return plainText;
}
